import React from 'react'

function Privacy() {
  return (
    <div>
    </div>
  )
}

export default Privacy
